import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {AlarmsEdasTypes} from '../../../../../shared/types/edas-alarms.type';
import EdasAlarms = AlarmsEdasTypes.EdasAlarms;

import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import EdasTypeAlert = AlarmsEdasTypes.EdasTypeAlert;
import EdasTypeTrigger = AlarmsEdasTypes.EdasTypeTrigger;
import EdasRelay = AlarmsEdasTypes.EdasRelay;
import EdasTypeAlarm = AlarmsEdasTypes.EdasTypeAlarm;
import EdasAlarm = AlarmsEdasTypes.EdasAlarm;

@Component({
  selector: 'app-edas-alarms',
  templateUrl: './edas-alarms.component.html',
  styleUrls: ['./edas-alarms.component.css']
})
export class EdasAlarmsComponent implements OnInit, AfterViewInit {
  @Input() edasAlarms: EdasAlarms;
  edasAlarmsMatTableDataSource: MatTableDataSource<EdasAlarm>;
  displayedColumns: string[] = AlarmsEdasTypes.edasAlarmDisplayedColumns;
  filter = '';

  @ViewChild(MatSort) sort: MatSort;

  constructor() {
  }

  ngOnInit(): void {
    this.edasAlarmsMatTableDataSource = new MatTableDataSource(this.edasAlarms.alarms);
  }

  ngAfterViewInit(): void {
    this.edasAlarmsMatTableDataSource.sort = this.sort;
    this.applyFilter();
  }

  applyFilter(filterValue: string = ''): void {
    this.filter = filterValue.trim().toLowerCase();
    this.edasAlarmsMatTableDataSource.filter = this.filter;
  }

  getColorType(value: any): string {
    const colorMap = {
      [EdasTypeAlert.Normal]: 'orange',
      [EdasTypeTrigger.Amplitude]: 'orange',
      [EdasTypeAlert.High]: '#e91e63',
      [EdasTypeTrigger.Max]: '#e91e63',
      [EdasRelay.R2]: '#e91e63',
      [EdasTypeAlarm.Dyn]: '#e91e63',
      [EdasRelay.None]: '#cccccc'
    };

    const color = colorMap[value] || 'yellowgreen';
    return `cursor: pointer; background-color: ${color}`;
  }
}

